import React, { forwardRef, useImperativeHandle } from 'react';
import * as rsuite from 'rsuite';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Drp_CheckBookPage = forwardRef((props, ref) => {

    const toaster = rsuite.useToaster();

    const [List, setList] = React.useState([]);
    const [Id, setId] = React.useState(General.GuidEmpty());
    const _Onchange = (value) => {
        props.onChange(value == null ? General.GuidEmpty() : value, value == null ? "" : List.find(x => x.Id == value).Title)
        setId(value)
    }
    useImperativeHandle(ref, () => ({

        Bind(BankAccountId, id) {
            console.dir(BankAccountId)
            var RequestOptions = {
                data: {
                    "BankAccountId": BankAccountId,
                    "IsActive": 1,
                },
                url: General.ApiRoute() + "/CheckBook/SearchPage",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }


            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        var temp = [];
                        console.dir(result)
                        for (let index = 0; index < result.data.length; index++) {
                            temp.push({
                                Id: result.data[index].id,
                                Title: result.data[index].pageNo
                            })
                            if ( result.data[index].id == id) {
                                props.onChange(result.data[index].id, result.data[index].pageNo)
                                setId(result.data[index].id);
                            }
                        }
                        setList(temp);

                    }).catch((error) => {
                        console.dir(error)
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                    })
            )
        },

    }))



    return (
     
            <rsuite.SelectPicker
                data={List}
                valueKey="Id"
                labelKey="Title"
                className='w-100p'
                placeholder="انتخاب کنید..."
                value={Id}
                onChange={(value) => _Onchange(value)}

            />


    )
});

export default Drp_CheckBookPage;